import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { getAuthState } from '../auth/slice'
import { useLazyGetDirectLinkMediaFileBinaryQuery } from './api'
import { redirectUser } from './utils'

export const useGetMediaFile = () => {
  const { isAuthenticated, isFirstLogin, isOidc } = useAppSelector(getAuthState)
  const dispatch = useAppDispatch()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const mediaStringId = params.get('media_string_id') ?? ''

  const [getFile, { isFetching, isLoading, isSuccess, isError }] =
    useLazyGetDirectLinkMediaFileBinaryQuery()

  useEffect(() => {
    if (isAuthenticated && mediaStringId) getFile(mediaStringId)
  }, [isAuthenticated, mediaStringId])

  useEffect(() => {
    if (isSuccess) redirectUser(isFirstLogin, isOidc, dispatch)
  }, [isSuccess, isFirstLogin, isOidc])

  return {
    isAuthenticated,
    isLoading: isFetching || isLoading,
    isSuccess,
    isError,
  }
}
